import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef, ViewChild, effect } from '@angular/core';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
// import { ActionService } from 'src/app/shared/services/action/action.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import * as _ from 'lodash'
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import { forkJoin, catchError, of } from 'rxjs';
import { ScoreWidgetComponent } from 'src/app/shared/components/score/score-widget/score-widget.component';
import { ScoreDropdownMenuComponent } from '../../../../score/score-dropdown-menu/score-dropdown-menu.component';
import { ScoreWidgetComponent as ScoreWidgetComponent_1 } from '../../../../score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { ScoreTableComponent } from '../../../../score/score-table/score-table.component';
import { LtmsLoaderComponent } from '../../../../ltms-loader/ltms-loader.component';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';

@Component({
    selector: 'app-engagement-records-summary-drilldown',
    templateUrl: './engagement-records-summary-drilldown.component.html',
    styleUrl: './engagement-records-summary-drilldown.component.scss',
    imports: [ScoreDropdownMenuComponent, ScoreWidgetComponent_1, NgIf, ScoreTableComponent, LtmsLoaderComponent]
})
export class EngagementRecordsSummaryDrilldownComponent {
  @Input() overallData: any = {};
  @Input() displayName: string = "";
  @Input() selectedOption: any = {}
  @Input() isDeviationEnabled = false;
  deviationComparisonLabel = '';
  @Input() componentId: string = "ltms-hierarchy-" + this.getTimeStamp();
  @Output() onFiltersChange: any = new EventEmitter<any>();
  @Output() onDrilldownChange = new EventEmitter<any>();

  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;

  field_id: string = "h_0_1";
  title: string = 'Records Summary';
  discription: string = 'Summarized Records performance by various hierarchy levels, detailing Records Delivered, Responses Received, Response Rate, and Unresponded Records.';
  timestamp: number = new Date().getTime();
  childDataCount: number = 0;
  containerId: string = "ltms-hierarchy-table-container" + this.timestamp
  accountDetails: any = {}
  downloadQueryParams: any = {}
  downloadReportOverallHeader: any = [];
  downloadReportDrilldownHeader: any = [];
  viewTypeDropdown: any = { config: { width: '128px', isDisabled: true, tab: 'engagementSummaryTable' }, selectedOption: '', options: [] };
  childStaticId = "Child-Summery"
  overallStaticId = "Overall-Summary"
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  isAccountManager: boolean = false;
  isAccount: boolean = false
  fullScreenLeftBox: boolean = false;
  showPercentage: boolean = false;
  brandId: string = '';
  fromDate: string = '';
  toDate: string = '';
  date_filter_type: number = 1;
  // rater_type: number = 0;
  project_type: number = 0;
  dropdown: any = {
    groupBy: "category",
    isDefaultSelection: true,
    categorization: true,
    preffix: "By ",
    elementid: 'ltms-dropdown-' + this.timestamp,
    options: []
  }
  childData = {
    elementId: "child-summary-" + this.timestamp,
    config: {
      shorting_enabled: true,
    },
    data: [],
    columns: []
  }

  drillDownList: any = []
  appliedDrilldownList: any = []
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  selectedCustomFilter: any = {}
  keysToFormat = [
  "number_of_request_generated_rated",
  "number_of_unique_requests_delivered",
  "notResponded"]


  filterObj: any = {
    currentFilter: {},
    nextFilter: {},
    appliedfilters: [],
    next: {}
  }

  subAccountData: any = {}
  brandDetails: any = {};
  hierarchyStack: any = [];
  hierarchyList: any = [];
  hierarchyListAliasValue: any = [];
  hierarchyMapping: any = {};
  currentHierarchyLevel: any = '';
  currentHierarchyLevelName: any = '';
  apiParameters: any = [];
  addOnList: boolean = true;
  exportData: any = [];
  // questionMapping: any = {};
  group_key_alias: string = '';
  startDate: any = '';
  endDate: any = '';

  overAllTableId: string = `${this.overallStaticId}-${this.getTimestamp()}`;
  childTableId: string = `${this.childStaticId}-${this.getTimestamp()}`;
  overallTable: any = {
    isChildTable: false,
    columns: [],
    rows: []
  }
  overallSummaryTable: any = {
    tablePlugins: {
      isTableResize: true,
      deviationAlignment: true,
      alignAllDeviationColumns: true,
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  hierarchyTable: any = {
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  subAccountTable: any = {
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  drilldownTable: any = {
    isChildTable: false,
    columns: [],
    rows: []
  }
  isHierarchyTableHidden = false;
  isDataLoaded: boolean = false;
  isHieararchyTableLoaded: boolean = false;
  // TODO: implement functionality to store hierarchy data
  selectedHerarchy: any = {};

  constructor(
    private _analytics: ResponseAnalyticsService,
    private engagementService: EngagementService,
    private _utilsService: UtilsService,
    private _helpers: HelpersService,
    private _toast: ToastService,
    private destroyRef: DestroyRef,
    private appStateService: AppStateService
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        this.filterObj = {
          currentFilter: {},
          nextFilter: this.viewTypeDropdown.options[0],
          appliedfilters: [],
          next: {}
        }
        let date: any = this.appStateService.datePicker();
        this.startDate = date.startDate;
        this.endDate = date.endDate;
        this.deviationComparisonLabel = this._helpers.getDeviationComparisonLabel(date);
        this.accountDetails = this.appStateService.accountDetails();
        this.brandDetails = this.appStateService.brandDetails();
        this.isAccountManager = _.get(Helpers, "isAccountManager");
        if (this.brandDetails?._id && (this.brandId != this.brandDetails?._id)) {
          this.brandId = this.brandDetails._id;
        } else {
          this.isDataLoaded = false;
        }
        this.hierarchyStack = this.appStateService.hierarchyStack()
        let project_type_obj: any = this.appStateService.projectType()
        this.project_type = project_type_obj?.project_type;
        this.setBrandDetail();
        this.isAccount = this.appStateService.isAccount();
        let isExpanded = this.engagementService.drilldownTable?.tableRow?.some(item => item.isExpanded);
        if (isExpanded &&
          this.brandDetails?._id && !this.isAccount &&
          (
            this.engagementService.engagemetState?.hierarchyStack == null ||
            _.isEqual(this.engagementService.engagemetState?.hierarchyStack, this.hierarchyStack)
          )) {
          this.hierarchyTable = this.engagementService.drilldownTable;
          this.isDataLoaded = false;
          this.getSelectedDrilldownData()
          const selectedFilter = this.engagementService.getSelectedDrilldownFilter()
          if (selectedFilter) {
            this.updateFilters(selectedFilter);
          }
          if (this.hierarchyMapping?.[this.hierarchyTable?.tableRow?.[0]?.field_id]) {
            this.viewTypeDropdown.selectedOption = this.hierarchyMapping?.[this.hierarchyTable?.tableRow?.[0]?.field_id]
          }
        } else if (!this.brandDetails?._id && this.isAccount) {
          const selectedFilter = this.engagementService.getSelectedDrilldownFilter()
          if (selectedFilter) {
            this.onDrilldownChange.emit(selectedFilter)
          }
          this.getChildData();
        } else {
          this.getChildData();
        }
        this.engagementService.engagemetState.hierarchyStack = this.hierarchyStack
      }
    })
    // Add event listeners for Escape key and click outside
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));

    this._helpers.datePicker.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((datePicker: any) => {
      if (datePicker) {
        this.deviationComparisonLabel = this._helpers.getDeviationComparisonLabel(datePicker);
      }
    });
  }

  scoreWidget(type: string): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true
    };
  }

  getTimeStamp() {
    return new Date().getTime();

  }
  ngOnInit(): void {
    // this._helpers.appState.pipe(
    //   takeUntilDestroyed(this.destroyRef)
    // ).subscribe((state: any) => {
    //   if (state && !state.pending) {
    //     this.filterObj = {
    //       currentFilter: {},
    //       nextFilter: this.viewTypeDropdown.options[0],
    //       appliedfilters: [],
    //       next: {}
    //     }
    //     this.startDate = state.datePicker.startDate;
    //     this.accountDetails = state.accountDetails;
    //     this.endDate = state.datePicker.endDate;
    //     this.hierarchyStack = state.hierarchyStack
    //     this.project_type = state?.projectType?.project_type;
    //     if (state.brandDetails?._id && (this.brandId != state.brandDetails?._id)) {
    //       this.brandId = state.brandDetails._id;
    //       this.brandDetail = state.brandDetails
          
    //     } else {
    //       this.isDataLoaded = false;
    //     }
    //     this.setBrandDetail();
    //     let isExpanded = this.engagementService.drilldownTable?.tableRow?.some(item => item.isExpanded);
    //     if (isExpanded &&
    //       state.brandDetails?._id &&
    //       (
    //         this.engagementService.engagemetState?.hierarchyStack == null ||
    //         _.isEqual(this.engagementService.engagemetState?.hierarchyStack, state.hierarchyStack)
    //       )) {
    //       this.hierarchyTable = this.engagementService.drilldownTable;
    //       this.isDataLoaded = false;
    //       this.getSelectedDrilldownData()
    //       const selectedFilter = this.engagementService.getSelectedDrilldownFilter()
    //       if (selectedFilter) {
    //         this.updateFilters(selectedFilter);
    //       }
    //       if (this.hierarchyMapping?.[this.hierarchyTable?.tableRow?.[0]?.field_id]) {
    //         this.viewTypeDropdown.selectedOption = this.hierarchyMapping?.[this.hierarchyTable?.tableRow?.[0]?.field_id]
    //       }
    //     } else if (!state.brandDetails?._id){
    //       const selectedFilter = this.engagementService.getSelectedDrilldownFilter()
    //       if (selectedFilter) {
    //         this.onDrilldownChange.emit(selectedFilter)
    //       }
    //       this.getChildData();
    //     } else {
    //       this.getChildData();
    //     }
    //   }
    //   this.engagementService.engagemetState.hierarchyStack = state.hierarchyStack
    // })
  }

  ngOnChanges() {
    this.initializeOverall();
    this.getChildData();
  }

  getSelectedDrilldownData(){
    let reqParams = this.getRequestParameters()
    delete reqParams?.field_id;
    delete reqParams?.hierarchy_stack;
    const drilldown_hierarchy = this.engagementService.generateApiParams(this.hierarchyTable?.tableRow, reqParams);
    const apiParams = drilldown_hierarchy.api_params;
    const filters = drilldown_hierarchy.filters;
    
    if(apiParams.length){
      let params = this.getRequestParameters()
      params.group_key_alias = this.group_key_alias
      if(this.hierarchyTable?.tableRow?.[0]?.field_id){
        params.field_id = this.hierarchyTable.tableRow[0]?.field_id;
      }
      params.from = this.startDate
      params.to = this.endDate
      this.applyComparisonApiDateRangeForPayload(params)
      this.engagementService.getEngagementSummary(params).subscribe(res => {
        this.isHieararchyTableLoaded = true;
        const updatedData = this.updateArrayWithData(this.hierarchyTable.tableRow, this.processChildData(res))
        // Format numbers using Indian locale
        this.hierarchyTable.tableRow = this.engagementService.formatNumberValuesInArray(updatedData, this.keysToFormat)
        this.downloadReportDrilldownHeader = this.getExportColumnsForReport(this.hierarchyMapping?.[this.hierarchyTable?.tableRow?.[0]?.field_id]||"Name")
      })
      
      if (apiParams.length > 0) {
        const apiCalls = apiParams.map(params => {
          this.applyComparisonApiDateRangeForPayload(params);
          return this.engagementService.getEngagementSummary(params).pipe(
            catchError(error => {
              return of(null); // Return null for failed requests
            })
          );
        });
        
        forkJoin<any[]>(apiCalls).subscribe(responses => {
          const validResponses = responses.filter(res => res !== null);
          if (validResponses.length != apiParams.length) {
            this.hierarchyTable.tableRow = [];
            this._toast.showPopup('ERROR', 'Error', 'Failed to fetch data. Please try again.', 5000);
            return;
          }
          
          const processedData = validResponses.map(res => this.processChildData(res));
          
          const sortedData = processedData.sort((a, b) => {
            const getFieldIdNumber = (group) => {
              if (group?.length) {
                const fieldId = group[0].field_id;
                const match = fieldId.match(/h_0_(\d+)/);
                return match ? parseInt(match[1], 10) : 0;
              }
              return 0;
            };
            return getFieldIdNumber(a) - getFieldIdNumber(b);
          });
          
          this.updateTableBySelectionHistory(sortedData, filters);
          this.isDataLoaded = true;
        });
      }
    }
  }
  updateTableBySelectionHistory(data: any[][], filters: any): void {
    this.recursivelyUpdateDrilldown(this.hierarchyTable.tableRow, filters, data, 0);
    // Format numbers after updating drilldown data
    this.hierarchyTable.tableRow = this.engagementService.formatNumberValuesInArray(this.hierarchyTable.tableRow, this.keysToFormat);
    this.isHieararchyTableLoaded = true;
    this.isDataLoaded = true;
  }
  recursivelyUpdateDrilldown(
    currentLevel: any[],
    filters: { field_id: string; group_key: string[] }[],
    data: any[][],
    levelIndex: number
  ): void {
    if (!currentLevel || currentLevel.length === 0) return;

    // First, create maps for all data arrays for quick lookups
    const dataMaps: Map<string, any>[] = [];
    for (let i = 0; i < data.length; i++) {
      const levelData = data[i];
      if (levelData && levelData.length > 0) {
        const map = new Map<string, any>();
        levelData.forEach(item => {
          map.set(`${item.name}_${item.field_id}`, item);
        });
        dataMaps[i] = map;
      }
    }

    // Recursively walk through the tree and update at any level
    const updateNodes = (nodes: any[], level: number = 0) => {
      if (!nodes || nodes.length === 0) return;
      
      for (const node of nodes) {
        // Check if we have data for this node at any level
        for (let i = 0; i < dataMaps.length; i++) {
          const map = dataMaps[i];
          if (map) {
            const key = `${node.name}_${node.field_id}`;
            if (map.has(key)) {
              const matchedData = map.get(key);
              // Update this node with the matched data
              node.notResponded = matchedData.notResponded;
              node.number_of_request_generated_rated = matchedData.number_of_request_generated_rated;
              node.number_of_unique_requests_delivered = matchedData.number_of_unique_requests_delivered;
              node.responseRate = matchedData.responseRate;
            }
          }
        }
        
        // Continue recursion if there's a drillDown
        if (node.drillDown && node.drillDown.length > 0) {
          updateNodes(node.drillDown, level + 1);
        }
      }
    };
    
    // Start the recursive update process
    updateNodes(currentLevel);
  }
  mergeDrilldownData(existing: any[], incoming: any[]): any[] {
    const updated = [...existing];

    incoming.forEach((item) => {
      const index = updated.findIndex((e) => e.field_id === item.field_id && e.name === item.name);
      if (index === -1) {
        updated.push(item);
      } else {
        updated[index] = {
          ...updated[index],
          ...item,
        };
      }
    });

    return updated;
  }
  updateArrayWithData(baseArray, dataArray) {
    const dataMap = new Map(
      dataArray.map(item => [`${item.name}_${item.field_id}`, item])
    );

    // Update existing objects in baseArray
    const updatedArray = baseArray.map(obj => {
      const key = `${obj.name}_${obj.field_id}`;
      if (dataMap.has(key)) {
        const matched = dataMap.get(key) as any;
        return {
          ...obj,
          notResponded: matched.notResponded,
          number_of_request_generated_rated: matched.number_of_request_generated_rated,
          number_of_unique_requests_delivered: matched.number_of_unique_requests_delivered,
          responseRate: matched.responseRate
        };
      }
      return obj;
    });

    // Add new objects from dataArray whose key is not present in baseArray
    const baseKeys = new Set(baseArray.map(obj => `${obj.name}_${obj.field_id}`));
    const newObjects = dataArray.filter(item => !baseKeys.has(`${item.name}_${item.field_id}`));

    return [...updatedArray, ...newObjects];
  }
  onFilterChange(data: any) {
    this.isDataLoaded = false;
    this.appliedDrilldownList = [];
    this.filterObj.appliedfilters = [];
    this.drillDownList = [];
    this.drilldownTable.rows = [];
    this.filterObj.nextFilter = data
    this.selectedCustomFilter = data
    this.viewTypeDropdown.selectedOption = data.name
    this.hierarchyTable.tableHeader = this.getExportColumns(this.selectedCustomFilter.name);
    this.group_key_alias = this.engagementService.getGroupAlias(data.field_id)
    this.field_id = data.field_id
    this.onDrilldownChange.emit({
      filters: this.filterObj.appliedfilters
    })
    this.initializeOverall();
    this.engagementService.clearDrilldownHistory();
    this.getChildData()
  }

  onViewChange(viewType: any) {
    this.showPercentage = (viewType == 'percent') ? true : false
    this.updateColumns()
    this.overAllTableId = `${this.overallStaticId}-${this.getTimestamp()}`;
    this.childTableId = `${this.childStaticId}-${this.getTimestamp()}`;
  }

  updateColumns() {
    if (!_.isEmpty(this.overallTable.rows)) {
      const displayName = this.overallTable.columns[0].header;
      this.overallTable.columns = this.getExportColumns(displayName)
    }
    if (!_.isEmpty(this.drilldownTable.rows)) {
      const level_name = this.drilldownTable.columns[0].header;
      this.drilldownTable.columns = this.getExportColumns(level_name);
      this.drilldownTable.rows = this.mapColumns(this.drilldownTable.rows);
    }
  }

  mapColumns(list: any) {
    return _.map(list, (object: any) => {
      if (_.hasIn(object, 'child.rows') && !_.isEmpty(object.child.rows)) {
        const lavel_name = object.child.columns[0].header;
        object.child.columns = this.getExportColumns(lavel_name);
        object.child.rows = this.mapColumns(object.child.rows);
      }
      return object
    })
  }


  initializeOverall() {
    this.exportData = []
    this.prepareDownloadQuery(this.overallData.query)
    // TODO: passe selected hierarchy or brand name insteade of "Project"
    this.overallTable.columns = this.getExportColumns('Project');
    if (this.hierarchyStack?.length || Helpers.isAccount) {
      this.overallSummaryTable.tableHeader = Helpers.isAccount ? this.getExportColumns("Account") : this.getExportColumns(this.hierarchyMapping[this.currentHierarchyLevel]);
    } else {
      this.overallSummaryTable.tableHeader = this.getExportColumns("Project");
    }
    this.hierarchyTable.tableHeader = this.getExportColumns(this.selectedCustomFilter['name']);
    this.overallTable.rows = this.overallData.data;
    if (this.overallData?.current) {
      this.overallData.current['responseRate'] = (this.engagementService.getResponsePercentage(this.overallData.current).toFixed(1) || 0);
      this.overallData.current['notResponded'] = 0
      if (this.overallData?.current?.number_of_unique_requests_delivered > this.overallData?.current?.number_of_request_generated_rated) {
        this.overallData.current['notResponded'] = ((this.overallData?.current?.number_of_unique_requests_delivered - this.overallData?.current?.number_of_request_generated_rated) || 0);
      }
      this.overallData.current['name'] = this.displayName;
      this.setEngagementRowDeviations(this.overallData.current, this.overallData?.previous);
      this.overallSummaryTable.tableRow = this.engagementService.formatNumberValuesInArray([this.overallData?.current], this.keysToFormat);
    }

    this.overAllTableId = "overall-summary-" + this.getTimestamp();
    this.downloadReportOverallHeader = this.overallSummaryTable.tableHeader;
    this.exportData.push({
      field_id: 'overall',
      order: this.exportData.length,
      columns: this.getExportColumnsForReport(this.hierarchyMapping[this.currentHierarchyLevel]),
      rows: this.overallData.data
    })
  }

  // TODO : assign processed data directly ot data.
  // updateDrilldownData(fromDate: string, toDate: string) {
  //   let drilldownHistory = this.engagementService.getDrilldownHistory();
  //   let response: any = []
  //   if(drilldownHistory.length>0){
  //     drilldownHistory.forEach( params => {
  //       params.from = fromDate;
  //       params.to = toDate;
  //       this.engagementService.getEngagementSummary(params).subscribe({
  //         next: (responseObject) => {
  //           if (this.validateApiResponse(responseObject)) {
  //             response.push(this.processChildData(responseObject))
  //           }
  //         }
  //       })

  //     })
  //   }
  //   console.log("response: : ", response)
  // }

  initDropdownOptions(options: any) {
    if (!_.isEmpty(options) && (options.length >= 1 || options[0]?.name == "Projects")) {
      // this.group_key_alias = 'brands'
      this.viewTypeDropdown.config.isDisabled = false;
      this.viewTypeDropdown.selectedOption = options[0].name
      this.viewTypeDropdown.options = options
      this.selectedCustomFilter = options[0]
      this.filterObj.nextFilter = this.selectedCustomFilter
      this.dropdown.options = options
      this.dropdown.elementid = 'ltms-dropdown-' + new Date().getTime()
    } else if (this.currentHierarchyLevel && this.hierarchyMapping?.[this.currentHierarchyLevel]) {
      this.viewTypeDropdown.config.isDisabled = false;
      this.viewTypeDropdown.options.push({ name: this.hierarchyMapping?.[this.currentHierarchyLevel], field_id: this.currentHierarchyLevel, field_type: 'hierarchy', category: 'Hierarchy' })
      this.viewTypeDropdown.selectedOption = this.hierarchyMapping?.[this.currentHierarchyLevel]
      this.isHierarchyTableHidden = true;
      this.selectedCustomFilter.name = this.hierarchyMapping?.[this.currentHierarchyLevel];
    } else if (this.isAccountManager){
      this.viewTypeDropdown.config.isDisabled = false;
      this.currentHierarchyLevel = 'h_0_0';
      this.viewTypeDropdown.options.push({ name: this.hierarchyMapping?.[this.currentHierarchyLevel], field_id: this.currentHierarchyLevel, field_type: 'hierarchy', category: 'Hierarchy' })
      this.viewTypeDropdown.selectedOption = this.hierarchyMapping?.[this.currentHierarchyLevel]
      this.isHierarchyTableHidden = true;
      this.selectedCustomFilter.name = this.hierarchyMapping?.[this.currentHierarchyLevel];
    } else {
      this.viewTypeDropdown.config.isDisabled = true;
    }
  }
// TODO: setting dropdown options needs separate method insted of in setBrandDetail()
  setBrandDetail(): void {
    // this.project_type = _.get(this.brandDetail, 'project_type');
    if(this.brandDetails){
      this.engagementService.configureEngagementService(this.brandDetails)
    }
    const dropdownDetails = this.engagementService.prepareViewTypeDropdown(this.brandDetails, this.hierarchyStack);
    var options: any = dropdownDetails.options;
    this.hierarchyMapping = dropdownDetails.hierarchyMapping
    this.currentHierarchyLevel = dropdownDetails.currentHierarchyLevel
    this.group_key_alias = dropdownDetails.group_alias_key
    this.initDropdownOptions(options)
    this.initializeOverall();
    this.drilldownTable.rows = []
    this.isDataLoaded = false;
    // this.getChildData()
  }

  getTimestamp() {
    return new Date().getTime();
  }

  getChildData(event?: any) {
    // this.isDataLoaded = false;
    const displayName = _.get(this.filterObj, 'nextFilter.name', 'Name')
    const fieldId = _.get(this.filterObj, 'nextFilter.field_id', '')

    let params = this.getRequestParameters()
    params.group_key_alias = this.group_key_alias
    params.from = this.startDate
    params.to = this.endDate
    this.applyComparisonApiDateRangeForPayload(params)
    if(event?.brand_ids && event?.brand_ids.length){
      params.brand_id_list = event?.brand_ids;
      params.field_type = "brand";
    } else {
      params.hierarchy_stack = this.filterObj?.appliedfilters?.length ? this.filterObj?.appliedfilters : params.hierarchy_stack;
    }
    params.field_id = Helpers.isAccount ? params.field_id : this.filterObj?.nextFilter?.field_id;
    params.field_type = this.filterObj?.nextFilter?.type;
    this.engagementService.getEngagementSummary(params).subscribe({
      next: (responseObject) => {
        if (this.validateApiResponse(responseObject)) {
          this.isHieararchyTableLoaded = true;
          let rowData: any = [];
          const columns = this.getExportColumns(displayName)
          this.childData.elementId = "child-summary-" + this.getTimestamp();
          let rows = this.processChildData(responseObject)
          this.subAccountData = responseObject;

          this.exportData.push({
            field_id: fieldId,
            order: this.exportData.length,
            columns: this.getExportColumnsForReport(displayName),
            rows: this.processChildData(responseObject)
          });

          if (rows && rows.length) {
            _.each(rows, row => {
              rowData.push(row)
            })
          }

          if (event && event.drillDown) {
            event.drillDown = rowData;
            event.columns = columns;
            event.header = this.getExportColumnsForReport(displayName)
            // this.engagementService.addDrilldownHistory(_.clone(params), this.hierarchyTable)
            this.engagementService.getInitializedTable(this.hierarchyTable)
            if(rowData.length == 0){
              event.is_error = true;
              event.isLoading = false;
            }
          } else {
            this.hierarchyTable.tableRow =  rows?.length ? this.engagementService.formatNumberValuesInArray(rows, this.keysToFormat) : [];
            this.downloadReportDrilldownHeader = this.getExportColumnsForReport(displayName)
          }

          if (rows && rows.length >= 100) {
            // sorting button is hiding incase of more than 100 rows
            this.hierarchyTable.tableHeader = _.map(this.hierarchyTable.tableHeader, column => {
              column.isSorting = false;
              return column;
            })
            this._toast.showPopup('WARN', 'Warning', 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', 7000);
            const exportQuery = this.prepareDownloadQuery(params);
            this.downloadQueryParams = exportQuery;
            // this.widgetConfig["downloadFromJob"] = true;
            // this.widgetConfig.download.query = exportQuery;
          } else {
            // this.widgetConfig.download.data.hasMultipleReports = true;
            // this.widgetConfig.download.data.rows = this.exportData;
          }
          let data: any = _.get(responseObject.data, 'overall_summary', {});
          if (!_.isEmpty(data)) {
            this.isDataAvailable = true;
          } else {
            this.isDataAvailable = false;
          }
          this.isDataLoaded = true;
        }
        else {
          this.isDataLoaded = true;
          this.isDataAvailable = false;
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }

  validateApiResponse(response: any) {
    return (response.code == 0 && _.hasIn(response, 'data.overall_summary_details') && !_.isEmpty(response.data.overall_summary_details))
  }

  onDrillDown(data?: any) {
    if(data.isExpanded){
      this.engagementService.getInitializedTable(this.hierarchyTable)
      // this.engagementService.removeDrilldownHistory(data?.field_id, this.hierarchyTable)
    }
    if(data?.field_type == "project" || Helpers.isAccount){
      if (data?.field_id != "project") {
        this.processChildData(this.subAccountData)
        this.subAccountTable.tableRow.forEach(row => {
          if (row.key == data.key && !data.isExpanded) {
            row.isExpanded = true;
          } else {
            row.isExpanded = false;
          }
        })
        this.engagementService.getInitializedTable(this.subAccountTable)
      }
      this.updateSubAccountData(data)
    } else {
      this.updateFilters(data);
    } 
  }

  updateFilters(data?: any) {
    this.engagementService.setSelectedDrilldownFilter(data)
    // this.exportData = this.exportData.splice(this.exportData.length - 1, 1);
    this.apiParameters = this.apiParameters.splice(this.apiParameters.length - 1, 1);
    if (data.filters) {
      this.filterObj.appliedfilters = JSON.parse(JSON.stringify(data.filters));
    }
    // Set data as current filter that
    this.filterObj.currentFilter = JSON.parse(JSON.stringify(data));
    // TODO: update the download functionality
    if (this.addOnList) {
      this.exportData.push({
        field_id: data.field_id,
        order: this.exportData.length,
        columns: this.getExportColumnsForReport(data.field_name),
        rows: [data]
      })
    }

    if (data.field_type == 'hierarchy') {
      this.filterObj.nextFilter = this.engagementService.getNextHierarchy(data.field_id)
      this.selectedCustomFilter = this.filterObj.nextFilter
    } else if (data.field_type == 'touchpoint') {
      this.filterObj.nextFilter = {};
    } else if (data.field_type == 'tag' || data.field_type == 'response') {
      if (data.field_child && !_.isEmpty(data.field_child)) {
        this.filterObj.nextFilter = JSON.parse(JSON.stringify(data.field_child));
        // If field type is response then set it as type and change type of question to sub_type
        if (data.field_type && data.field_type == 'response') {

          // if (data.type == "multi-select") {
          //   this.filterObj.nextFilter = this.actionService.getPrpsAndPossibleValuesForMultiSelect(this.filterObj.nextFilter);
          // }

          this.filterObj.nextFilter.field_sub_type = JSON.parse(JSON.stringify(this.filterObj.nextFilter.type));
          this.filterObj.nextFilter.type = 'response';
        } else {
          this.filterObj.nextFilter.type = 'tag';
        }
      } else {
        this.filterObj.nextFilter = {};
      }
    }

    var applyFilterObj = {
      field_id: data.field_id,
      field_type: data.field_type,
      field_sub_type: data.field_sub_type,
      field_value: data.name,
      group_key: [data.name],
      field_data_type: data.field_data_type
    }
    if (applyFilterObj.field_type == 'hierarchy') {
      if (!isNaN(applyFilterObj.field_value)) {
        applyFilterObj.field_value = parseInt(applyFilterObj.field_value);
      }
      if (applyFilterObj.field_sub_type == 'multi-select') {
        _.each(this.filterObj.currentFilter.field_possible_values, function (obj: any) {
          if (obj.value == applyFilterObj.field_value) {
            applyFilterObj.field_id = obj.field_id;
          }
        });
      }
    }
    
    const currentLevel = parseInt(applyFilterObj?.field_id?.split('_')[2]);
    
    this.filterObj.appliedfilters = this.filterObj.appliedfilters.filter(filter => {
      const filterLevel = parseInt(filter.field_id.split('_')[2]);
      return filterLevel < currentLevel;
    });

    // Add the new filter
    this.filterObj.appliedfilters.push(applyFilterObj);
    if (data.field_id != 'touchpoint') {
      this.group_key_alias = data.field_id
      this.onDrilldownChange.emit({
        filters: this.filterObj.appliedfilters,
        groupKeyAlias: this.group_key_alias
      })
      this.getChildData(data)
    }

  }
  updateSubAccountData(data) {
    let filters = {
      filters: [{field_value: data?.name}],
      projectId: data?.projectId
    }
    this.engagementService.setSelectedDrilldownFilter(filters)
    if (data?.brand_ids?.length && this.subAccountTable?.tableRow?.length) {
      this.subAccountTable.tableRow.forEach(rowData => {
        if (data._id == rowData._id && rowData?.drillDown?.length) {
          filters["brand_id_list"] = rowData.drillDown.map(drilldown => drilldown?.projectId)
        }
      })
    } else if (this.isAccount && 'projectId' in filters) {
      filters["brand_id_list"] = [data?.projectId]
      delete filters.projectId;
    }
    this.onDrilldownChange.emit(filters)
  }

  removeDrillDown(data: any) {
    if (data.field_id != 'touchpoint') {
      this.group_key_alias = data.field_id
      const index = _.findIndex(this.appliedDrilldownList, { field_id: data.field_id })
      this.appliedDrilldownList.splice(index + 1, this.appliedDrilldownList.length)
      this.filterObj.appliedfilters.splice(index + 1, this.filterObj.appliedfilters.length)

      const exportDataIndex = _.findIndex(this.exportData, { field_id: data.field_id })
      this.exportData.splice(exportDataIndex + 1, this.exportData.length)

      const exportQueryIndex = _.findIndex(this.apiParameters, { field_id: data.field_id })
      this.apiParameters.splice(exportQueryIndex + 1, this.apiParameters.length)

      this.filterObj.currentFilter = data
      if (data.field_type == "hierarchy") {
        this.filterObj.nextFilter = this.engagementService.getNextHierarchy(data.field_id)
      } else {
        this.filterObj.nextFilter = this.selectedCustomFilter
      }
      this.onDrilldownChange.emit({
        filters: this.filterObj.appliedfilters,
        groupKeyAlias: this.group_key_alias
      })
      this.getChildData()
    }
  }

  resetHierarchData() {
    this.engagementService.clearDrilldownHistory();
    let selectedFilter = this.viewTypeDropdown?.options.find(item => item.name === this.viewTypeDropdown?.selectedOption)
    this.onFilterChange(selectedFilter)
  }

  getRequestParameters() {
    var params: any = {}

    params = this.engagementService.getSummaryParams({
      "rater_type": 3,
      "query_type": 1,
      "view_type": "hierarchy",
      "dates": { from: this.fromDate, to: this.toDate },
      "is_deviation_enabled": this.isDeviationEnabled,
    })
    if (Helpers.isAccount) {
      params.field_id = "project";
      if (this.project_type) {
        params.project_type = this.project_type;
      }
    } else {
      params.field_id = this.field_id;
    }
    params.limit = 101;
    return params
  }

  private applyComparisonApiDateRangeForPayload(payload: any): void {
    if (!payload) {
      return;
    }
    applyComparisonApiDateRange(payload, Helpers?.datePicker);
  }

  getMappedData(response: any, columns: any) {
    let list = _.get(this.drilldownTable, 'rows', []);
    const childData: any = this.processChildData(response);
    if (!_.isEmpty(list)) {
      // this.drilldownTable.rows = this.mapChildData(list, columns, childData)
      this.hierarchyTable.tableRow = this.mapChildData(list, columns, childData)
    } else {
      this.drilldownTable.columns = columns
      // this.drilldownTable.rows = childData
      this.hierarchyTable.tableHeader = columns
      this.hierarchyTable.tableRow = childData
    }
    this.childTableId = `${this.childStaticId}-${this.getTimestamp()}`;
  }

  mapChildData(list: any, columns: any, childData: any) {
    return _.map(list, (object: any) => {
      if (object.field_id == this.selectedHerarchy.field_id && object.name == this.selectedHerarchy.name) {
        object.child = {
          isChildTable: true,
          columns: columns,
          rows: childData
        }
      } else if (_.hasIn(object, 'child.rows') && !_.isEmpty(object.child.rows)) {
        const rows = _.get(object, 'child.rows', [])
        object.child.rows = this.mapChildData(rows, columns, childData)
      }
      return object;
    })
  }

  processChildData(response: any) {
    let excluded_brands = [""];
    if (response?.data?.overall_summary_details?.sub_accounts) {
      const data = response?.data?.overall_summary_details?.sub_accounts;
      const subAccountTableRow = this.aggregateSubAccountData(response?.data?.overall_summary_details);
      this.subAccountTable.tableRow =  this.engagementService.formatNumberValuesInArray(subAccountTableRow, this.keysToFormat)
      this.subAccountTable.tableHeader = this.getExportColumns("Sub Accounts");
      let isExpanded = this.engagementService.drilldownTable?.tableRow?.some(item => item.isExpanded);
      if (isExpanded) {
        let matchFound = false;
        this.engagementService.drilldownTable?.tableRow.forEach(row => {
          if (row?.isExpanded) {
            this.subAccountTable?.tableRow.forEach(saRow => {
              if (row?.key == saRow?.key) {
                saRow.isExpanded = true;
                matchFound = true;
              }
            })
          }
        })
        if (!matchFound) {
          if (this.engagementService.drilldownTable.tableRow.length) {
            const existingSubAccounts = new Set(this.subAccountTable.tableRow.map(item => item._id));
            const initializedSubAccounts = this.engagementService.drilldownTable.tableRow.filter(item => !existingSubAccounts.has(item._id));
            this.subAccountTable.tableRow = [...this.subAccountTable.tableRow, ...initializedSubAccounts];
          }
        }
      }
      for (let key in data) {
        if (data[key].brand_ids) {
          excluded_brands = excluded_brands.concat(data[key].brand_ids);
        }
      }
      this.downloadReportOverallHeader = this.getExportColumnsForReport("Account")
    }
    let ratingSummary: any = _.get(response, 'data.overall_summary_details.overall_summary', {});
    let hierarchyMap = _.get(response, 'data.overall_summary_details.groups', {});
    let brandMap = _.get(response, 'data.overall_summary_details.brands', {});
    let list: any = [];
    this.childDataCount = 0;
    if (!_.isEmpty(ratingSummary)) {
      for (let key in ratingSummary) {
        if (ratingSummary.hasOwnProperty(key)) {
          // Skip the brands that are excluded
          if (excluded_brands.indexOf(key) !== -1) {
            continue;
          }
          let object: any = {};

          object.name = key || "NA";
          if (Helpers.isAccount) {
            object.name = brandMap[key]?.name || "NA";
            object.projectId = key;
          }
          object.key = hierarchyMap[key]?.level + '_' + object.name;
          object.field_id = hierarchyMap[key]?.level;
          object.level_name = this.hierarchyMapping[object.field_id] || this.filterObj?.nextFilter?.name;
          object.field_type = this.filterObj?.nextFilter?.type || this.filterObj?.nextFilter?.field_type;
          object.number_of_request_generated_rated = ratingSummary[key]?.summary?.current?.number_of_request_generated_rated || 0;
          object.number_of_unique_requests_delivered = ratingSummary[key]?.summary?.current?.number_of_unique_requests_delivered || 0;

          if (ratingSummary?.[key]?.summary?.current) {
            object.responseRate = (this.engagementService.getResponsePercentage(ratingSummary[key]?.summary?.current).toFixed(1) || 0);
            object['notResponded'] = 0
            if (object.number_of_unique_requests_delivered > object.number_of_request_generated_rated) {
              object['notResponded'] = ((object.number_of_unique_requests_delivered - object.number_of_request_generated_rated) || 0);
            }
          }
          this.setEngagementRowDeviations(object, ratingSummary?.[key]?.summary?.previous);
          // object.drillDown = [];
          object.isChildExists = !this.engagementService.isEndOfHierarchy(object?.field_id);
          object.isChildExists = Helpers.isAccount ? false : object.isChildExists
          object.filters = JSON.parse(JSON.stringify(this.filterObj?.appliedfilters));

          if (object.isChildExists) {
            object.drillDown = [];
          }

          this.childDataCount += 1;

          list.push(object);
        }
      }
    } 
    else {
      list = null;
    }
    // this.initializeOverall();
    if (this.childDataCount > 100) {
      list.splice(100, this.childDataCount);
    }
    return list;
  }

  getPercentage(count: number, total: number) {
    let percentage: any = '';
    percentage = (((count / total) * 100)).toFixed(1);
    if (percentage >= 0) {
      return percentage;
    } else {
      return '0.0'
    }
  }

  processDrilldownData(data: any) {
    if (this.filterObj && this.filterObj.nextFilter && this.filterObj.nextFilter.field_id) {
      data.field_id = this.filterObj.nextFilter.field_id;
      data.field_name = this.filterObj.nextFilter.name;
      data.field_type = this.filterObj.nextFilter.type || this.filterObj.nextFilter.field_type;
      data.field_sub_type = this.filterObj.nextFilter.field_sub_type;
      data.field_data_type = this.filterObj.nextFilter.data_type;
      data.field_possible_values = this.filterObj.nextFilter.possible_values;
      data.field_child = this.filterObj.nextFilter.child;
    } else if (this.filterObj && this.filterObj.currentFilter && this.filterObj.currentFilter.field_id) {
      data.field_id = this.filterObj.currentFilter.field_id;
      data.field_name = this.filterObj.currentFilter.field_name;
      data.field_type = this.filterObj.currentFilter.field_type || this.filterObj.currentFilter.type;
      data.field_sub_type = this.filterObj.currentFilter.field_sub_type;
      data.field_data_type = this.filterObj.currentFilter.field_data_type || this.filterObj.currentFilter.data_type;
      data.field_possible_values = this.filterObj.currentFilter.field_possible_values || this.filterObj.currentFilter.possible_values;
      data.field_child = this.filterObj.currentFilter.field_child || this.filterObj.currentFilter.child;
    } else if (this.selectedCustomFilter) {
      if (this.selectedCustomFilter.field_type && this.selectedCustomFilter.field_type == 'response') {
        data.field_type = this.selectedCustomFilter.field_type;
        data.field_sub_type = this.selectedCustomFilter.type;
      } else {
        data.field_type = this.selectedCustomFilter.type;
      }
      data.field_id = this.selectedCustomFilter.field_id;
      data.field_name = this.selectedCustomFilter.name;
      data.field_data_type = this.selectedCustomFilter.data_type;
      data.field_possible_values = this.selectedCustomFilter.possible_values;
      data.field_child = this.selectedCustomFilter.child;
    }
    return data
  }
  aggregateSubAccountData(data) {
    const aggregatedSubAccounts: any[] = [];

    for (const sub_account_id in data.sub_accounts) {
      const sub_account = data.sub_accounts[sub_account_id];
      let displayName = sub_account?.name ? sub_account?.name : "Projects";
      let drilldownBrands: any = []
      let total_request_generated_rated = 0;
      let total_unique_requests_delivered = 0;
      let total_request_generated = 0;
      let total_requests_received = 0;
      let prev_request_generated_rated = 0;
      let prev_unique_requests_delivered = 0;
      let prev_request_generated = 0;
      let prev_requests_received = 0;

      sub_account.brand_ids.forEach(brand_id => {
        let brand_summary:any = data?.overall_summary?.[brand_id]?.summary?.current || {};

        brand_summary.name = data?.brands?.[brand_id]?.name || "";
        brand_summary.key = data?.brands?.[brand_id]?.name || "";
        brand_summary.isChildExists = false;
        brand_summary.field_id = "project";
        brand_summary.projectId = brand_id;

        // Add the values to the totals
        total_request_generated_rated += brand_summary?.number_of_request_generated_rated || 0;
        total_unique_requests_delivered += brand_summary?.number_of_unique_requests_delivered || 0;
        total_request_generated += brand_summary?.number_of_request_generated || 0;
        total_requests_received += brand_summary?.number_of_requests_received || 0;
        if (_.has(brand_summary, 'number_of_request_generated_rated') &&
          _.has(brand_summary, 'number_of_unique_requests_delivered') &&
          _.has(brand_summary, 'number_of_request_generated') &&
          _.has(brand_summary, 'number_of_requests_received')) {
          brand_summary.responseRate = (this.engagementService.getResponsePercentage(brand_summary).toFixed(1) || 0);
          let notResponsed = (brand_summary.number_of_unique_requests_delivered - brand_summary.number_of_request_generated_rated);
          brand_summary.notResponded = notResponsed >= 0 ? notResponsed : 0;
          this.setEngagementRowDeviations(brand_summary, data?.overall_summary?.[brand_id]?.summary?.previous);
          const previous = data?.overall_summary?.[brand_id]?.summary?.previous;
          if (previous) {
            prev_request_generated_rated += previous.number_of_request_generated_rated || 0;
            prev_unique_requests_delivered += previous.number_of_unique_requests_delivered || 0;
            prev_request_generated += previous.number_of_request_generated || 0;
            prev_requests_received += previous.number_of_requests_received || 0;
          }
          drilldownBrands.push(brand_summary);
        }
      });

      let total_summary = {
        number_of_request_generated_rated: total_request_generated_rated,
        number_of_unique_requests_delivered: total_unique_requests_delivered,
        number_of_request_generated: total_request_generated,
        number_of_requests_received: total_requests_received
      }
      if (
        total_request_generated_rated > 0 ||
        total_unique_requests_delivered > 0 ||
        total_request_generated > 0 ||
        total_requests_received > 0
      ) {
        const totalNotResponded = (total_unique_requests_delivered - total_request_generated_rated)
        const aggregatedSubAccount = {
          ...sub_account,
          number_of_request_generated_rated: total_request_generated_rated,
          number_of_unique_requests_delivered: total_unique_requests_delivered,
          number_of_request_generated: total_request_generated,
          number_of_requests_received: total_requests_received,
          responseRate: (this.engagementService.getResponsePercentage(total_summary).toFixed(1) || 0),
          notResponded: totalNotResponded >= 0 ? totalNotResponded : 0,
          key: sub_account?.name || sub_account?._id,
          drillDown:  drilldownBrands,
          header: this.getExportColumnsForReport("Sub-account Projects"),
          columns: this.getExportColumns("Sub-account Projects", true)
        };
        const previousTotals = {
          number_of_request_generated_rated: prev_request_generated_rated,
          number_of_unique_requests_delivered: prev_unique_requests_delivered,
          number_of_request_generated: prev_request_generated,
          number_of_requests_received: prev_requests_received,
        };
        this.setEngagementRowDeviations(aggregatedSubAccount, previousTotals);
        aggregatedSubAccounts.push(aggregatedSubAccount);
      }
    }
    return aggregatedSubAccounts;
  }

  setEngagementRowDeviations(row: any, previous: any) {
    if (!row) {
      return;
    }
    if (!this.isDeviationEnabled || !previous || _.isEmpty(previous)) {
      row.deviations = {};
      return;
    }
    const prevRate = this.engagementService.getResponsePercentage(previous);
    const prevNotResponded = Math.max((previous.number_of_unique_requests_delivered || 0) - (previous.number_of_request_generated_rated || 0), 0);
    row.deviations = {
      number_of_unique_requests_delivered: Helpers.getFieldDeviation(row.number_of_unique_requests_delivered, previous.number_of_unique_requests_delivered),
      number_of_request_generated_rated: Helpers.getFieldDeviation(row.number_of_request_generated_rated, previous.number_of_request_generated_rated),
      responseRate: Helpers.getFieldDeviation(row.responseRate, prevRate),
      notResponded: Helpers.getFieldDeviation(row.notResponded, prevNotResponded),
    };
  }

  prepareDownloadQuery(query: any) {
    if (query && !_.isEmpty(query)) {
      let downloadQuery: any = {};
      let overallParams = this.engagementService.getDetailsParams({
        "query_type": 1,
        "is_trend_data": false,
        "field_id": "h_0_0",
        "view_type": 'hierarchy',
        "trend_type": '',
        from: this.fromDate,
        to: this.endDate,
      })
      let selectedHierarchyParams = this.engagementService.getDetailsParams({
        "query_type": 1,
        "is_trend_data": false,
        "field_id": this.selectedCustomFilter.field_id,
        "view_type": 'hierarchy',
        "trend_type": '',
        from: this.fromDate,
        to: this.endDate,
      })
      downloadQuery.account_id = this.accountDetails?._id;
      downloadQuery.brand_id = this.brandId;
      downloadQuery.field_id = this.selectedCustomFilter.field_id;
      downloadQuery.column_type = "Summary"
      downloadQuery.api_url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.EngagementSummaryByAccount);
      downloadQuery.parameters = [];
      downloadQuery.report_name = 'Engagement Summary - By ' + this.selectedCustomFilter.name;
      downloadQuery.file_name =  'Engagement Summary - By ' + this.selectedCustomFilter.name;
      downloadQuery.report_type = "statistics_advanced_download";
      downloadQuery.parameters = [overallParams,selectedHierarchyParams];
      return downloadQuery
    }
    return {}
  }

  getExportColumns(display_name?: string, isProject = false) {
    let columns: any = [];
    var name = {
      header: display_name || 'Name',
      uniqueId: 'name',
      width: '170px',
      isSorting: true,
      isDrilldown: true,
      isClickable: true,
      isProject: display_name == "Projects" ? true : isProject,
      dataKey: "name",
      defaultValue: "",
      showPercentage: false,
      order: "1"
    };

    var recordsDelivered = {
      header: "Records Delivered",
      dataKey: 'number_of_unique_requests_delivered',
      uniqueId: 'number_of_unique_requests_delivered',
      width: '150px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "2"
    }

    var responseReceived = {
      header: "Responses Received",
      dataKey: 'number_of_request_generated_rated',
      uniqueId: 'number_of_request_generated_rated',
      width: '160px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "3"
    }

    var responseRate = {
      header: "Response Rate (%)",
      dataKey: 'responseRate',
      uniqueId: 'responseRate',
      width: '140px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      showPercentage: false,
      defaultValue: 0,
      order: "4"
    }

    var notResponded = {
      header: "Not Responded",
      dataKey: 'notResponded',
      uniqueId: 'notResponded',
      width: '150px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      showPercentage: false,
      defaultValue: 0,
      order: "5"
    }

    columns = [name, recordsDelivered, responseReceived, responseRate, notResponded]
    return columns
  }

  getExportColumnsForReport(display_name?: string) {
    let columns: any = [];
    var name = {
      header: display_name || 'Name',
      uniqueId: 'name',
      width: '220px',
      isSorting: true,
      isDrilldown: true,
      isClickable: false,
      dataKey: "name",
      defaultValue: "",
      showPercentage: false,
      order: "1"
    };

    var recordsDelivered = {
      header: "Records Delivered",
      dataKey: 'number_of_unique_requests_delivered',
      uniqueId: 'number_of_unique_requests_delivered',
      width: '120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "2"
    }

    var responseReceived = {
      header: "Responses Received",
      dataKey: 'number_of_request_generated_rated',
      uniqueId: 'number_of_request_generated_rated',
      width: '120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "3"
    }

    var responseRate = {
      header: "Response Rate (%)",
      dataKey: 'responseRate',
      uniqueId: 'responseRate',
      width: '120px',
      isSorting: true,
      showPercentage: false,
      defaultValue: 0,
      order: "4"
    }

    var notResponded = {
      header: "Not Responded",
      dataKey: 'notResponded',
      uniqueId: 'notResponded',
      width: '120px',
      isSorting: true,
      showPercentage: false,
      defaultValue: 0,
      order: "5"
    }

    columns = [name, recordsDelivered, responseReceived, responseRate, notResponded]
    return columns
  }

  onDownload() {
    if (this.childDataCount < 100) {
      let overallData = {
        columns: this.downloadReportOverallHeader,
        rows: this.overallSummaryTable.tableRow
      }
      let formattedSubAccountRow = []
      if (this.subAccountTable.tableRow.length) {
        formattedSubAccountRow = this.subAccountTable.tableRow.map(item => {
          return {
            ...item,
            drillDown: item?.isExpanded ? item?.drillDown : [],
          };
        })
      }
      let subAccountData = {
        columns: this.subAccountTable.tableHeader,
        rows: formattedSubAccountRow
      }
      let hierarchyData = {
        columns: this.downloadReportDrilldownHeader,
        rows: this.hierarchyTable.tableRow
      }
      let downloadConfig: any = {
        dataKey: 'uniqueId',
        headerKey: 'header',
        data: [overallData, hierarchyData]
      }
      if (this.subAccountTable?.tableRow?.length) {
        downloadConfig.data = [overallData, subAccountData, hierarchyData]
      }
      if (this.isHierarchyTableHidden){
        downloadConfig.data = [overallData] 
      }
      downloadConfig.fileDetails = {
        title: 'Engagement Summary - By_' + this.selectedCustomFilter.name,
        fileName: 'Engagement Summary - By_' + this.selectedCustomFilter.name,
        accountName: this.accountDetails?.display_name || this.accountDetails?.name,
        brandName: this.brandDetails?.display_name || this.brandDetails?.name
      }

      if (downloadConfig.data.length) {
        this._analytics.prepareAndDownloadData(downloadConfig);
      }
    } else {
      this.engagementService.createDownloadJob(this.downloadQueryParams);
    }
  }

  onFullscreenLeftBox(event, cardName): void {
    this.fullScreenLeftBox = event;
  }

  // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.fullScreenLeftBox) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('engagement-hierarchy-summary'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.fullScreenLeftBox && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    this.engagementService.filters = [];
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }
}
